import useAuth from "../../../hooks/useAuth";
import ConnectedBanksSection from "../../../components/bank/ConnectedBanksSection";
import "../../../styles/bankRecordDetail.css";

export default function LinkedBankRecords() {
  const { auth } = useAuth();
  const isRepoAdmin = auth?.user?.role === "REPO_ADMIN";

  return (
    <div className="page">
      <div style={{ marginBottom: 24 }}>
        <h2 style={{ marginBottom: 4 }}>Bank/NBFC Repo List Details</h2>
        <p className="muted" style={{ fontSize: 14 }}>
          {isRepoAdmin
            ? "Records uploaded by banks linked to your agency. Open a row for full Excel details including banker names and mobiles."
            : "Bank recovery data from banks linked to your agency (same cases as admin; loan and banker contacts are admin-only)."}
        </p>
      </div>

      <ConnectedBanksSection />
    </div>
  );
}
